import gql from "graphql-tag"

const TeamPerksMetrics = gql`
  query TeamPerksMetrics($tenantId: ID!) {
    teamPerksMetrics(tenantId: $tenantId){
      teams {
        name
        id
        redemption_count
        perksgo_count
        perksgo_saving_total
        estimated_perks_savings
        admins
        team {
          teamState
          users {
            total
          }
        }
      }
    }
  }
`

export default TeamPerksMetrics
